<template>
  <v-container fluid pt-10 pl-0 pt-0 pb-10 ma-0>
    <v-row align="stretch" justify="space-around">
      <v-col md="9" sm="12">
        <v-card class="justify-center" elevation="2" outlined shaped>
          <v-card-title class="text-h2 justify-center">
            Almost Ready!
          </v-card-title>
          <v-row gutter ma-0 class="justify-center">
            <v-col cols="9">
              <p style="text-align: center" class="text-h6">
                It's almost time to certify for Cyber Essentials, just take the
                following actions and you'll be ready
              </p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <template v-for="(cardInfo, Qindex) of resultCards" )>
      <!-- Start Rec Card Row -->
      <template>
        <v-row align="stretch" justify="space-around">
          <v-col md="9" sm="12">
            <v-card class="justify-center" elevation="2" outlined shaped>
              <v-card-text pa-4>
                <p class="text-h4" :class="cardInfo.compliant">
                  <v-icon
                    v-if="cardInfo.compliant == 'noncompliant'"
                    x-large
                    style="color: red"
                    dark
                    >mdi-alert-octagon-outline</v-icon
                  >
                  <v-icon
                    v-if="cardInfo.compliant == 'compliant'"
                    x-large
                    style="color: green"
                    dark
                    >mdi-check-circle-outline</v-icon
                  >
                  {{ cardInfo.question }}
                </p>
                <p :class="cardInfo.compliant">
                  {{ cardInfo.recommendation }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <!-- End Rec Card Row -->
    </template>
  </v-container>
</template>
 

<script>
import axios from "axios";

export default {
  name: "Show Results",
  data() {
    return {
      questionBlobs: undefined,
      steps: 0,
    };
  },
  mounted() {
    if (localStorage.getItem("sub") != 1) {
      this.$router.push("/");
    }
    this.questionBlobs = this.$store.getters.getQuestionBlobs;
    this.steps = this.questionBlobs.length;
    this.LogAnswers();
  },
  components: {},
  methods: {
    LogAnswers: async function (event) {
      //aHR0cHM6Ly9ob29rcy56YXBpZXIuY29tL2hvb2tzL2NhdGNoLzc1OTI4MjMvYmZxNW9sei8=
      var hook = atob(
        "aHR0cHM6Ly9ob29rcy56YXBpZXIuY29tL2hvb2tzL2NhdGNoLzc1OTI4MjMvYmZxNW9sei8="
      );
      console.log("zap!");
      var email = this.$store.getters.getEmail;
      var QA = [];
      for (var currQuestionCatagory in this.questionBlobs) {
        //console.log(this.questionBlobs[currQuestionCatagory])
        for (var currQuestion in this.questionBlobs[currQuestionCatagory]
          .questionSet) {
          console.log(
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
          );
          let question =
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
              .question.question;
          let answer =
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
              .Answer;
          let triggerAnswer =
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
              .RecTriggerAnswer;
          let recommendation =
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
              .Recommendation;
          var quezzy = { Q : question+' : '+ answer };
          QA.push(quezzy);
        }
      }
      console.log(email)
      var sendjson = {
        Email: email,
        QSet: QA,
      };
      const res = await axios
        .create({
          transformRequest: [(data, _headers) => JSON.stringify(data)],
        })
        .post(hook, sendjson);
    },
  },
  computed: {
    // a computed getter
    resultCards() {
      let sorted = [];
      let rightAnswers = [];
      let wrongAnswers = [];
      // `this` points to the component instance
      //console.log(this.questionBlobs)
      for (var currQuestionCatagory in this.questionBlobs) {
        //console.log(this.questionBlobs[currQuestionCatagory])
        for (var currQuestion in this.questionBlobs[currQuestionCatagory]
          .questionSet) {
          console.log(
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
          );
          let question =
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
              .question.question;
          let answer =
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
              .Answer;
          let triggerAnswer =
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
              .RecTriggerAnswer;
          let recommendation =
            this.questionBlobs[currQuestionCatagory].questionSet[currQuestion]
              .Recommendation;
          if (triggerAnswer === null || !triggerAnswer) {
            console.log("skipping");
            continue;
          }
          if (answer == triggerAnswer) {
            //wrong answer
            console.log("wrong answer");
            var wrongAnswer = {
              compliant: "noncompliant",
              question: question,
              recommendation: recommendation,
            };
            wrongAnswers.push(wrongAnswer);
          } else {
            if (answer != triggerAnswer) {
              console.log("right answer");
              //right answer
              var rightAnswer = {
                compliant: "compliant",
                question: question,
                recommendation: recommendation,
              };
              rightAnswers.push(rightAnswer);
            }
          }
        }
      }
      //add to array in final order
      for (var card in wrongAnswers) {
        //push wrong answer
        sorted.push(wrongAnswers[card]);
      }
      for (var card in rightAnswers) {
        //push right answer
        sorted.push(rightAnswers[card]);
      }
      return sorted;
    },
  },
};
</script>


<style scoped>
.compliant {
  color: rgb(195, 191, 191);
}
</style>